module.exports = __webpack_public_path__ + "img/149ne.ed96dc14.svg";